export const regexs = {
  CNPJ_REGEX: /^[A-Z0-9]{2}\.?[A-Z0-9]{3}\.?[A-Z0-9]{3}\/?[A-Z0-9]{4}-?\d{2}$/i,
  CPF_REGEX: /^\d{3}\.\d{3}\.\d{3}-\d{2}$/,
  CPJ_AND_CNPJ_REGEX: /(^\d{3}\.\d{3}\.\d{3}-\d{2}$)|(^[A-Z0-9]{2}\.?[A-Z0-9]{3}\.?[A-Z0-9]{3}\/?[A-Z0-9]{4}-?\d{2}$)/i,
  CPF_AND_CNPJ_REGEX: /(^\d{3}\.\d{3}\.\d{3}-\d{2}$)|(^[A-Z0-9]{2}\.?[A-Z0-9]{3}\.?[A-Z0-9]{3}\/?[A-Z0-9]{4}-?\d{2}$)/i,
  CEP_REGEX: /^\d{5}-\d{3}$/,
  PHONE_REGEX: /^\(\d{2}\)\s\d{4}-\d{4}$/
};
